import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tenants from './pages/Tenants';
import CancellationRequests from './pages/CancellationRequests';
import Staff from './pages/Staff';
import Plans from './pages/Plans';
import ApiKeys from './pages/ApiKeys';
import Applications from './pages/Applications';
import NetworkPartners from './pages/NetworkPartners';
import Commissions from './pages/Commissions';
import CommissionSettings from './pages/CommissionSettings';
import RegionsAreas from './pages/RegionsAreas';
import AuditLog from './pages/AuditLog';
import RepActivity from './pages/RepActivity';
import Marketing from './pages/Marketing';
import SendPlans from './pages/SendPlans';
import MarketingWizard from './pages/MarketingWizard';
import EngagementLeads from './pages/EngagementLeads';
import CampaignResults from './pages/CampaignResults'; /* CAMPAIGN_RESULTS_v1 */
import CampaignDetail from './pages/CampaignDetail'; /* CAMPAIGN_ROUTE_v2 */
import Databases from './pages/Databases';

function Protected({ children }) {
  const { isAuth } = useAuth();
  return isAuth ? <Layout>{children}</Layout> : <Navigate to="/login" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/tenants" element={<Protected><Tenants /></Protected>} />
          <Route path="/cancellation-requests" element={<Protected><CancellationRequests /></Protected>} />
          <Route path="/staff" element={<Protected><Staff /></Protected>} />
          <Route path="/plans" element={<Protected><Plans /></Protected>} />
          <Route path="/api-keys" element={<Protected><ApiKeys /></Protected>} />
          <Route path="/applications" element={<Protected><Applications /></Protected>} />
          <Route path="/network-partners" element={<Protected><NetworkPartners /></Protected>} />
          <Route path="/commissions" element={<Protected><Commissions /></Protected>} />
          <Route path="/commission-settings" element={<Protected><CommissionSettings /></Protected>} />
          <Route path="/regions-areas" element={<Protected><RegionsAreas /></Protected>} />
          <Route path="/audit-log" element={<Protected><AuditLog /></Protected>} />
          <Route path="/rep-activity" element={<Protected><RepActivity /></Protected>} />
          <Route path="/marketing" element={<Protected><Marketing /></Protected>} />
          <Route path="/send-plans" element={<Protected><SendPlans /></Protected>} />
          <Route path="/marketing-wizard" element={<Protected><MarketingWizard /></Protected>} />
          <Route path="/engagement-leads" element={<Protected><CampaignResults /></Protected>} />
          <Route path="/campaign/:id" element={<Protected><CampaignDetail /></Protected>} />
          <Route path="/engagement-leads-old" element={<Protected><EngagementLeads /></Protected>} />
          <Route path="/databases" element={<Protected><Databases /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
